import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SSOProvider from "./components/SSOProvider.js";
import UnsavedChangesDialog from "./components/UnsavedChangesDialog";
import { saveItemSession } from "./utils/session";

export const RootLayout = () => {
  const location = useLocation();

  useEffect(() => {
    const currentUrl = `${location.pathname}${location.search}`;
    if (!currentUrl.includes("code=")) {
      saveItemSession("lastVisitedURL", currentUrl);
    }
  }, [location.pathname, location.search]);

  return (
    <SSOProvider
      clientId={process.env.REACT_APP_CONSUMER_KEY}
      redirectUri={process.env.REACT_APP_REDIRECT_URI}
    >
      <Outlet />
      <UnsavedChangesDialog />
    </SSOProvider>
  );
};
